import FileCard from 'components/FileCard'
import SimpleLoader from 'components/SimpleLoader'
import { MyFile } from 'interfaces'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { selectedContentItemsSelector } from 'services/content/selectors'
import styles from './LibraryPhotosGrid.pcss'

const PAGE_SIZE = 20

export function LibraryPhotosGrid(props: {
  files: MyFile[],
  page: number,
  loading: boolean,
  error: boolean,
  onSelect: (url: string) => void
}) {
  const { files, page, loading, error, onSelect } = props
  const selectedItems = useSelector(selectedContentItemsSelector)
  const visibleItems = useMemo(() => {
    return files.slice(0, (page + 1) * PAGE_SIZE)
  }, [files, page])

  const handleClick = (f: MyFile) => {
    onSelect(f.url)
  }

  return (
    <section className={styles.grid}>
      {loading && (
        <SimpleLoader small />
      )}
      {!loading && error && (
        <p className={styles.error}>
          <FormattedMessage id="errors.generic-support" />
        </p>
      )}
      {visibleItems.map(file => (
        <FileCard 
          key={file.key} 
          file={file} 
          hideDetails
          className={styles.file}
          selected={Boolean(selectedItems[file.id])} 
          onClick={handleClick}
        />
      ))}
    </section>
  )
}

export default LibraryPhotosGrid
